export default __webpack_public_path__ + "static/media/C6.c1de431a.mp3";